// export const url = {
//      site: "",
//      lecteur : "http://localhost:5173",
//      websocket: "http://localhost:8070/",
//  };

export async function fetcher<JSON = any>(
    input: RequestInfo,
    init?: RequestInit
): Promise<JSON> {
    const res = await fetch(input, init);
    return res.json();
}

export const url = {
    site : "https://plateforme.reverto.fr",
    lecteur : "https://lecteur.reverto.fr",
    websocket : "https://plateforme.reverto.fr"
}

// export const url = {
//     site : "https://plateforme-staging.reverto.fr",
//     lecteur : "https://lecteur-staging.reverto.fr",
//     websocket : "https://plateforme-staging.reverto.fr"
// }

export const siteVersion = "v 0.14.1"
